import React from 'react';

interface EducationSectionProps {
  studies: Array<{
    name: string;
    startDate: string;
    finishDate: string;
    institution: {
      name: string;
    };
  }>;
}

const EducationSection: React.FC<EducationSectionProps> = ({ studies }) => {
  const formatDate = (dateString: string) => {
    if (!dateString) return 'Presente';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', { year: 'numeric' });
  };

  return (
    <div className="education-list">
      {studies.map((study: any, index: number) => (
        <div key={index} className="education-item">
          <div className="education-content">
            <div className="education-info">
              <h4 className="degree-name">{study.name}</h4>
              <p className="institution-name">{study.institution.name}</p>
            </div>
            <div className="education-dates">
              {formatDate(study.startDate)} - {formatDate(study.finishDate)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EducationSection;